export * from './aside'
export * from './main'
export * from './home'
export * from './gift1'
export * from './gift2'
export * from './gift3'
export * from './bonus'
